import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import FilterGrid from './components/FilterGrid';
import Recipes from './components/Recipes';
import About from './components/About';
import Booking from './components/Booking';
import JoinUs from './components/JoinUs';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import { CartProvider } from './contexts/CartContext';
import Cart from './components/Cart';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import Membership from './components/Membership';
import MemberInterface from './components/MemberInterface';

function App() {
  const [activePage, setActivePage] = useState('home');

  return (
    <AuthProvider>
      <Router>
        <CartProvider>
          <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar activePage={activePage} onPageChange={setActivePage} />
            <Cart />
            
            <main className="relative pt-24 flex-grow">
              <Routes>
                <Route path="/" element={<><Hero /><FilterGrid onCategoryClick={(category) => setActivePage(category)} /><JoinUs /></>} />
                <Route path="/about" element={<About />} />
                <Route path="/chicken" element={<Products category="chicken" />} />
                <Route path="/beef" element={<Products category="beef" />} />
                <Route path="/pork" element={<Products category="pork" />} />
                <Route path="/fish" element={<Products category="fish" />} />
                <Route path="/halal" element={<Products category="halal" />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/booking" element={<Booking />} />
                <Route 
                  path="/membership" 
                  element={
                    <ProtectedRoute>
                      <Membership />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/member" 
                  element={
                    <ProtectedRoute>
                      <MemberInterface />
                    </ProtectedRoute>
                  } 
                />
                <Route path="*" element={<Navigate to="/" />} /> {/* Redirect to home for undefined routes */}
              </Routes>
            </main>

            <Footer />
          </div>
        </CartProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
